import { z } from 'zod';

/**
 * Validation schemas for the partner company endpoint.
 */

export const zodPartnerCompanySchema = z.object({
  companyAccountId: z.uuid(),
  id: z.uuid(),
  name: z.string(),
});
